module.exports = __webpack_public_path__ + "static/img/05.a1fcf34a.png";